import { render, staticRenderFns } from "./RepeatableAtFaultClaims.vue?vue&type=template&id=038e85ce&"
import script from "./RepeatableAtFaultClaims.vue?vue&type=script&lang=js&"
export * from "./RepeatableAtFaultClaims.vue?vue&type=script&lang=js&"
import style0 from "./RepeatableAtFaultClaims.vue?vue&type=style&index=0&id=038e85ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports